import {usersUrls} from "../helpers/Urls";
import axios from "axios";

const getProvince = async ()=>{
    const {data} = await axios.get(usersUrls.getProvince);
    return data
}
export default getProvince